import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import DomesticSearchProxy from '../proxies/DomesticSearchPreviewProxy'

class DomesticSearchService extends ServiceBase {
  getDomesticSearchDetail(params) {
    return this.getData(() =>
      DomesticSearchProxy.getDomesticSearchDetail(params),
    )
  }
}

export default new DomesticSearchService()
